import { USER } from "../../../types";
import { Document } from "../../../types/documents.type";

export const getLeadSign = (document: Document | null) => {
  return (
    document?.sign_file?.find((sign) => {
      return sign?.user?.type === USER.LEAD;
    }) || null
  );
};
